module.exports = __webpack_public_path__ + "static/media/robo.5a603965.png";